import { render, staticRenderFns } from "./CampaignStatus.vue?vue&type=template&id=4da48702&scoped=true"
import script from "./CampaignStatus.vue?vue&type=script&lang=js"
export * from "./CampaignStatus.vue?vue&type=script&lang=js"
import style0 from "./CampaignStatus.vue?vue&type=style&index=0&id=4da48702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da48702",
  null
  
)

export default component.exports